import * as React from "react";
function SvgChevronRight(props, svgRef) {
  return <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}><path d="M9 18L15 12L9 6" style={{
      stroke: "var(--svg-color, #000)"
    }} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
const ForwardRef = React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "src/assets/icons/chevron_right.svg";
export const Scaled = {
  "0.5x": __webpack_public_path__ + "src/assets/icons/chevron_right_0.5x.svg",
  "1x": __webpack_public_path__ + "src/assets/icons/chevron_right_1x.svg",
  "2x": __webpack_public_path__ + "src/assets/icons/chevron_right_2x.svg",
  "3x": __webpack_public_path__ + "src/assets/icons/chevron_right_3x.svg",
  "4x": __webpack_public_path__ + "src/assets/icons/chevron_right_4x.svg"
};
export { ForwardRef as ReactComponent };